// Paths relative to API_BASE. Keep these aligned with the FastAPI routes.
const jobPath = (prefix, jobId) => `${prefix}/${encodeURIComponent(jobId)}`;

export const API_ENDPOINTS = Object.freeze({
  login: "/login",
  register: "/register",
  me: "/me",
  vendors: "/vendors",
  convert: "/convert",
  vendorUpdate: "/vendor-update",
  variantInventory: "/variant-inventory-generator",
  preprocess: "/preprocess",
  inventoryUpdate: "/shopify/inventory-update",
  workflowKeySettings: "/settings/workflow-keys",
  workflowKey: (keyId) => jobPath("/settings/workflow-keys", keyId),
  workflow: Object.freeze({
    vendors: "/workflow/vendors",
    inventory: "/workflow/inventory",
    job: (jobId) => jobPath("/workflow/jobs", jobId),
    artifact: (jobId, artifact) =>
      `${jobPath("/workflow/jobs", jobId)}/artifacts/${encodeURIComponent(artifact)}`,
  }),
  progress: (jobId) => jobPath("/progress", jobId),
  download: (jobId) => jobPath("/download", jobId),
  skuMatch: Object.freeze({
    sync: "/sku-match/sync",
    syncStatus: "/sku-match/sync-status",
    compare: "/sku-match/compare",
    history: "/sku-match/history",
    historyRecord: (jobId) => jobPath("/sku-match/history", jobId),
    download: (jobId) => jobPath("/sku-match/download", jobId),
    view: (jobId, sheet = "skus") =>
      `${jobPath("/sku-match/view", jobId)}?${new URLSearchParams({ sheet })}`,
  }),
});
